import React, { Component } from "react";
import PropTypes from "prop-types";
import Link from "gatsby-link";
import styled from "styled-components";
import { RichText } from "prismic-dom";
import { Box, Flex } from "rebass";
import { wordWrap } from "polished";
import {
  Head,
  H2,
  H3,
  H4,
  Text,
  Card,
  CardLayout,
  Main,
  PageHeader,
  PageContent,
  PageSection,
  Article,
  ResourceCard,
  UpdateCard,
  PrimaryButton,
  GradientCard,
} from "components";
import moment from "moment";

const Prismic = require("prismic-javascript");

let linkResolver = function (doc) {
  return "/" + doc.type;
};

const ContactLayout = styled(Flex)`
  align-items: stretch;

  @media (max-width: 40em) {
    flex-wrap: wrap;
    > * {
      width: 100%;
      margin-bottom: ${(props) => props.theme.space[6]}px;

      &:not(:lang(ar)) {
        margin-left: 0;
      }
      &:lang(ar) {
        margin-right: 0;
      }
    }
    > *:last-child {
      margin-bottom: ${(props) => props.theme.space[0]}px;
    }
  }
  @media (min-width: 40em) {
    flex-wrap: wrap;
    > * {
      width: ${(props) =>
        "calc(" + (1 / 2) * 100 + "% - " + props.theme.space[4] / 2 + "px)"};
      margin-bottom: ${(props) => props.theme.space[6]}px;

      &:not(:lang(ar)) {
        margin-left: ${(props) => props.theme.space[4]}px;
      }
      &:lang(ar) {
        margin-right: ${(props) => props.theme.space[4]}px;
      }
    }
    > *:nth-child(2n + 1) {
      &:not(:lang(ar)) {
        margin-left: 0;
      }
      &:lang(ar) {
        margin-right: 0;
      }
    }
    > *:nth-last-child(-n + 2) {
      margin-bottom: ${(props) => props.theme.space[0]}px;
    }
  }
`;

const CustomText = styled(Text)`
  ${wordWrap("break-word")};
`;

const ContactItem = (props) => (
  <Box mb={[5, 6]}>
    <H4 children={props.object.contact_purpose} mb={3} />
    <H3
      children={
        props.object.contact_name[0] ? props.object.contact_name[0].text : ""
      }
      mb={1}
    />
    {/* <CustomText children={props.object.contact_role} mb={3} /> */}
    {props.object.email && (
      <CustomText>
        <a href={"mailto:" + props.object.email} target="_blank">
          {props.object.email}
        </a>
      </CustomText>
    )}
    {props.object.phone && (
      <CustomText>
        <a href={"tel:" + props.object.phone} target="_blank">
          {props.object.phone}
        </a>
      </CustomText>
    )}
  </Box>
);

class Region extends React.Component {
  static contextTypes = {
    setAltLanguages: PropTypes.func,
  };
  componentDidMount() {
    if (this.props.data.page.alternate_languages) {
      this.context.setAltLanguages(this.props.data.page.alternate_languages);
    } else {
      this.context.setAltLanguages(undefined);
    }
  }
  render() {
    let json = "";
    if (this.props.data.page.raw) {
      json = JSON.parse(this.props.data.page.raw);
    }
    let showInactive = false;
    if (this.props.data.regionProjects) {
      this.props.data.regionProjects.edges.forEach((edge) => {
        if (
          edge.node.data.status === "Inactive" ||
          edge.node.data.status === "Canceled" ||
          edge.node.data.status === "Archived"
        ) {
          showInactive = true;
        }
      });
    }
    return (
      <div
        style={
          this.props.transition ? this.props.transition.style : { opacity: 0 }
        }
      >
        <Head
          source={{
            meta_title: [
              {
                text:
                  json.data.title !== undefined
                    ? json.data.title[0]
                      ? json.data.title[0].text + " | Bank Information Center"
                      : ""
                    : "",
              },
            ],
            meta_description: [
              {
                text:
                  json.data.description !== undefined
                    ? json.data.description[0]
                      ? json.data.description[0].text
                      : ""
                    : "",
              },
            ],
            social_sharing_image: {
              url:
                json.data.header_image !== undefined
                  ? json.data.header_image.url
                  : "",
            },
          }}
        />
        <Main>
          <PageHeader title={json.data.title[0].text} color={json.uid}>
            {json.data.subtitle[0] && (
              <H2 children={json.data.subtitle[0].text} fontSize={[4, 5]} />
            )}
            {json.data.description && (
              <Article
                dangerouslySetInnerHTML={{
                  __html: RichText.asHtml(json.data.description, linkResolver),
                }}
              />
            )}
          </PageHeader>
          {json.data.body1.length > 0 && (
            <PageSection>
              <PageContent>
                {json.data.body1.map((callout, index) => (
                  <Box mt={3}>
                    <GradientCard
                      key={"gradientCard" + index}
                      image={
                        callout.primary.callout_image
                          ? callout.primary.callout_image.url
                          : ""
                      }
                    >
                      <Box w={[1, null, 1 / 2]}>
                        {callout.primary.small_heading[0] && (
                          <H4
                            children={callout.primary.small_heading[0].text}
                            mb={5}
                          />
                        )}
                        {callout.primary.callout[0] && (
                          <H2
                            children={callout.primary.callout[0].text}
                            mb={5}
                            fontSize={[4, 5]}
                          />
                        )}
                        {callout.primary.subtext[0] && (
                          <Text
                            children={callout.primary.subtext[0].text}
                            fontSize={[2, 3]}
                            mb={5}
                          />
                        )}
                        {callout.primary.button_text && (
                          <PrimaryButton
                            children={callout.primary.button_text}
                            is={
                              callout.primary.button_file.url
                                ? "a"
                                : callout.primary.button_link
                                ? callout.primary.button_link.indexOf(
                                    "http"
                                  ) !== -1 ||
                                  callout.primary.button_link.indexOf(
                                    "mailto"
                                  ) !== -1
                                  ? "a"
                                  : Link
                                : Link
                            }
                            to={
                              "/" +
                              this.props.data.page.lang +
                              "/" +
                              callout.primary.button_link
                            }
                            href={
                              callout.primary.button_link
                                ? callout.primary.button_link
                                : callout.primary.button_file
                                ? callout.primary.button_file.url
                                : ""
                            }
                          />
                        )}
                      </Box>
                    </GradientCard>
                  </Box>
                ))}
              </PageContent>
            </PageSection>
          )}
          {json.data.contacts && (
            <PageSection>
              <PageContent>
                <ContactLayout>
                  {json.data.contacts.map((contact, index) => (
                    <ContactItem key={"contactItem" + index} object={contact} />
                  ))}
                </ContactLayout>
              </PageContent>
            </PageSection>
          )}
          {this.props.data.regionProjects && (
            <PageSection>
              <PageContent>
                <H2
                  children={
                    json.lang === "en-us"
                      ? "Ongoing Projects"
                      : json.lang === "es-mx"
                      ? "Proyectos en curso"
                      : "مشاريع جارية"
                  }
                  mb={5}
                />
                <CardLayout>
                  {this.props.data.regionProjects.edges.map(
                    (project, index) => {
                      if (
                        project.node.data.status === "Active" ||
                        project.node.data.status === "Approved" ||
                        project.node.data.status === "Proposed"
                      ) {
                        return (
                          <Card key={"project" + index} object={project.node} />
                        );
                      } else {
                        return null;
                      }
                    }
                  )}
                </CardLayout>
              </PageContent>
            </PageSection>
          )}
          {this.props.data.regionUpdates && (
            <PageSection column="true" borderTop="true">
              <H2
                children={
                  json.lang === "en-us"
                    ? "Related Updates"
                    : json.lang === "es-mx"
                    ? "Noticias"
                    : "التحديثات ذات الصلة"
                }
                mb={5}
                fontSize={[4, 5]}
              />
              <CardLayout w={1 / 1}>
                {this.props.data.regionUpdates.edges
                  .sort(function (a, b) {
                    if (
                      moment(a.node.data.publish_date).utc() <
                      moment(b.node.data.publish_date).utc()
                    )
                      return 1;
                    if (
                      moment(a.node.data.publish_date).utc() >
                      moment(b.node.data.publish_date).utc()
                    )
                      return -1;
                    return 0;
                  })
                  .slice(0, 4)
                  .map((update, index) => (
                    <UpdateCard key={"project" + index} object={update.node} />
                  ))}
              </CardLayout>
              <Flex width="100%" justify="center">
                <Box pt={6}>
                  <PrimaryButton
                    mt={3}
                    children={
                      json.lang === "en-us"
                        ? "View More"
                        : json.lang === "es-mx"
                        ? "Más noticias"
                        : "عرض المزيد"
                    }
                    is={Link}
                    to={
                      "/" +
                      this.props.data.page.lang +
                      "/updates/?region=" +
                      this.props.data.page.prismicId
                    }
                    aria-label="View more updates"
                  />
                </Box>
              </Flex>
            </PageSection>
          )}
          {this.props.data.regionResources && (
            <PageSection column="true" borderTop="true">
              <H2
                children={
                  json.lang === "en-us"
                    ? "Related Resources"
                    : json.lang === "es-mx"
                    ? "Otros recursos"
                    : "موارد ذات الصلة"
                }
                mb={5}
                fontSize={[4, 5]}
              />
              <CardLayout w={1 / 1}>
                {this.props.data.regionResources.edges
                  .slice(0, 4)
                  .map((resource, index) => (
                    <ResourceCard
                      key={"resource" + index}
                      object={resource.node}
                    />
                  ))}
              </CardLayout>
              <Flex width="100%" justify="center">
                <Box pt={6}>
                  <PrimaryButton
                    children={
                      json.lang === "en-us"
                        ? "View More"
                        : json.lang === "es-mx"
                        ? "Más noticias"
                        : "عرض المزيد"
                    }
                    is={Link}
                    to={
                      "/" +
                      this.props.data.page.lang +
                      "/resources/?region=" +
                      this.props.data.page.prismicId
                    }
                    aria-label="View more resources"
                  />
                </Box>
              </Flex>
            </PageSection>
          )}
          {showInactive && (
            <PageSection column="true" borderTop="true">
              <PageContent>
                <Box>
                  <H2
                    children={
                      json.lang === "en-us"
                        ? "Inactive Projects"
                        : json.lang === "es-mx"
                        ? "Proyectos inactivos"
                        : "مشاريع غير نشطة"
                    }
                    mb={5}
                  />
                  <CardLayout>
                    {this.props.data.regionProjects.edges.map(
                      (project, index) => {
                        if (
                          project.node.data.status === "Inactive" ||
                          project.node.data.status === "Canceled" ||
                          project.node.data.status === "Archived"
                        ) {
                          return (
                            <Card
                              key={"project" + index}
                              object={project.node}
                            />
                          );
                        } else {
                          return null;
                        }
                      }
                    )}
                  </CardLayout>
                </Box>
              </PageContent>
            </PageSection>
          )}
        </Main>
      </div>
    );
  }
}

export default Region;

export const query = graphql`
  query RegionQuery($id: String!) {
    page: prismicDocument(prismicId: { eq: $id }) {
      raw
      prismicId
      uid
      id
      lang
      alternate_languages {
        uid
        lang
        type
      }
    }
    regionProjects: allPrismicDocument(
      filter: { type: { eq: "projec" }, data: { region: { id: { eq: $id } } } }
    ) {
      edges {
        node {
          uid
          type
          lang
          data {
            status
            region {
              uid
            }
            title {
              text
            }
            description {
              text
            }
            header_image {
              url
              quarter {
                url
              }
              half {
                url
              }
              thumb {
                url
              }
            }
          }
        }
      }
    }
    regionUpdates: allPrismicDocument(
      filter: { type: { eq: "update" }, data: { region: { id: { eq: $id } } } }
    ) {
      edges {
        node {
          uid
          type
          lang
          last_publication_date
          data {
            publish_date
            region {
              uid
            }
            title {
              text
            }
            description {
              text
            }
            header_image {
              url
              quarter {
                url
              }
              half {
                url
              }
              thumb {
                url
              }
            }
          }
        }
      }
    }
    regionResources: allPrismicDocument(
      filter: {
        type: { eq: "resource" }
        data: { region: { id: { eq: $id } } }
      }
    ) {
      edges {
        node {
          uid
          type
          lang
          last_publication_date
          data {
            region {
              uid
            }
            title {
              text
            }
            resource_description {
              text
            }
            post_type
            resource_link {
              url
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/layouts/region.js